import * as Sentry from "@sentry/react";

// Sentry はフロント側のランタイムエラー / パフォーマンス計測に利用する。
// DSN が未設定の環境（ローカル / プレビュー環境など）では初期化をスキップして無効化する。
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
